module.exports = __webpack_public_path__ + "components/flag/static/square/ro-b299a80239dbe469dc075c380c789d19.svg";